/*eslint-disable no-unreachable */
import React from 'react'
import * as actionCreators from '../../actions/ScheduleActions'

import { Dropdown, Menu, Modal, Header, Button, Icon, Loader } from 'semantic-ui-react'
import { Timeline, Track, TrackIndex, Timemarker } from './';
import {connect} from 'react-redux'
/*
 * ToDo: Moment kann entfernt werden, sobald die Demo Tracks ueber Redux definiert sind
 */
var moment = require('moment');
require('moment/locale/de');
var _ = require('lodash');

function getChannels(state){
	var consumers = state.channels.get('consumers');
	var channels = [{
		key: '_',
		value: '_',
		text: 'Alle Kanäle'
	}];
	
	if(typeof consumers !== 'undefined' && consumers !== null){
		consumers = consumers.toJSON();
		
		for(var consumerName in consumers){
			var consumer = consumers[consumerName];
			if(typeof consumer.channels !== 'undefined'){
				for(var channelIdx in consumer.channels){
					var c = consumer.channels[channelIdx];
					channels.push({
						key: c.id,
						value: c.id,
						text: c.name
					});
				}
			}else{
				channels.push({
					key: consumerName,
					value: consumerName,
					text: consumerName
				});	
			}
		}
	}
	
	return channels;
}

function getLotteries(state){
	var lotteries = [{
		key: '_',
		value: '_',
		text: 'Alle Lotterien'
	}];
	
	var l = state.lotteries.get('lotteries');
	
	if(typeof l !== 'undefined' && l !== null){
		l = _.values(l.toJSON());
		for(var el of l){
			lotteries.push({
				key: el['lottery-id'],
				value: el['lottery-id'],
				text: el.lottery
			});	
		}
	}	
	
	return lotteries;
}

function mapStateToProps (state, ownProps) {
	var lottery = state.lotteries.get('selected');
	if(typeof lottery === 'undefined' || lottery === null)
		lottery = '_';
	else if(lottery !== '_')
		lottery = parseInt(lottery);
		
	/*var channel = state.channels.get('selected');
	if(typeof channel === 'undefined' || channel === null)*
		channel = '_';*/
    var channel = '_';
	
	let s = state.schedule.getIn(['schedules', ownProps.id]);
		
	if(typeof s === 'undefined' || s === null)
		return {};
	
	let isDragging = s.get('dragging');
	let timespan = s.get('timespan');
	
	if(timespan !== null)
		timespan = timespan.toJSON();
	
	let schedule = s.getIn(['schedule', 'relevant']).toJS();
	let corresponding = s.getIn(['schedule', 'corresponding']).toJSON();
	
	let selectedItem = s.get('selectedItem');
	if(selectedItem !== null)
		selectedItem = selectedItem.toJSON();
	
	/*let channels = getChannels(state);
	let lotteries = getLotteries(state);*/
	
	let move_timestamp = s.get('move_timestamp_start');
	if(move_timestamp !== null)
		move_timestamp = [move_timestamp, s.get('move_timestamp_end')];	
	
	return {
		/*channels: channels,
		lotteries: lotteries,*/
		lottery: lottery,
		channel: channel,
		activeItem: s.get('activeItem'),
		grid_size: s.get('grid_size'),
		timestamp: s.get('drag_timestamp'),
		move_timestamp: move_timestamp,
		timespan: timespan,
		isDragging: isDragging,
		schedule: schedule,
        metaitems: (typeof ownProps.items !== 'undefined' && ownProps.items !== null)?ownProps.items:{},
		selectedItem: selectedItem,
		corresponding: corresponding,
        updating: s.get('updating'),
        loading: s.get('loading'),
        saving: ownProps.saving || s.get('updating')
	};
}

class ScheduleComponent extends React.Component {
	constructor(props) {
		super(props);
		this.onDragOverT = _.throttle(this.onDragOver, (__DEV__)?150:150);
		this.props.set_timespan(this.props.id, this.props.start, this.props.end, props.fetch_schedule);
	}

	onDragStart(e, action, trackIdx, item, params){
		e.dataTransfer.dropEffect = "move"
 		e.dataTransfer.setData("text", e.target.id);
		this.props.drag_start(this.props.id, action, trackIdx, item.index, params);
	}
	
	onDragEnd(e, action, trackIdx, item){
		e.stopPropagation();
		if(e.type !== 'mouseup' || (this.props.activeItem !== null && this.props.activeItem.action === 'move')){	
			this.props.drag_end(this.props.id);
		}
	}
	
	selectItem(scheduleId, itemIdx, trackIdx){
		if(this.props.activeItem !== null)
			this.props.end_create(this.props.id, null, trackIdx);
		else{
            if(typeof this.props.onSelectItem !== 'undefined'){
                if(typeof this.props.schedule[trackIdx] !== 'undefined' && typeof this.props.schedule[trackIdx].items[itemIdx] !== 'undefined'){
                    this.props.onSelectItem(this.props.schedule[trackIdx].items[itemIdx]);
                }
            }
			this.props.select_item(this.props.id, itemIdx, trackIdx);
        }
	}
	
	removeItem(scheduleId, itemIdx, trackIdx){
		this.props.remove_item(this.props.id, itemIdx, trackIdx);
	}
	
	/**
	 * Handle drag over on tracks
	 * 
	 * The method should never be called directly. The throttled wrapper function onDragOverT should be called instead.
	 * 
	 * @param float The position on the drag between 0.0 and 1.0
	 * @param Track The track
	 */
	onDragOver(e, x, trackIdx){
		//console.log(e, e.released);
		if(e.dispatchConfig !== null && this.props.activeItem && this.props.activeItem.get('action') === 'move' && e.buttons !== null && e.type !== null && e.type === 'mousemove' &&  e.buttons === 0){
			this.onDragEnd(e, 'move', trackIdx);
		}else{		
			//this.props.startOfWeek + Math.floor(minutesInWeek / step / width * x) * step;
			let timestamp = Math.round((this.props.timespan.start + this.props.timespan.seconds * x) / this.props.grid_size) * this.props.grid_size;
			if(this.props.isDragging && (this.props.timestamp === null || this.props.timestamp !== timestamp))
				this.props.set_drag_position(this.props.id, timestamp, trackIdx);
		}
	}
	
	create(x, trackIdx){
		let timestamp = Math.round((this.props.timespan.start + this.props.timespan.seconds * x) / this.props.grid_size) * this.props.grid_size;
		if(this.props.item === null)return;
		if(this.props.activeItem !== null)
			this.props.end_create(this.props.id, timestamp, trackIdx);
		else
			this.props.start_create(this.props.id, timestamp, trackIdx, this.props.item);
	}
	
	next(){
		let nextStart = moment(this.props.timespan.end * 1000).add(1, 'days').startOf('day').format('X');
		let nextEnd = moment(nextStart * 1000).add(6, 'days').endOf('day').format('X');
				
		this.props.set_timespan(this.props.id, nextStart, nextEnd, this.props.fetch_schedule);
	}
	
	prev(){
		let prevEnd = moment(this.props.timespan.start * 1000).add(-1, 'days').endOf('day').format('X');
		let prevStart = moment(prevEnd * 1000).add(-6, 'days').startOf('day').format('X');
				
		this.props.set_timespan(this.props.id, prevStart, prevEnd, this.props.fetch_schedule);
	}
	
	render() {		
		if(this.props.timespan === null || typeof this.props.schedule === 'undefined' || this.props.schedule === null)
			return null;
		
		return (
			<div style={{
				position: 'relative',
				display: 'flex',
				flexDirection: 'column',
				flexGrow: 1
			}}>
				<div style={{
					height: '25px',
					lineHeight: '25px',
					verticalAlign: 'middle',
					backgroundColor: '#EEEEEE',
					color: '#555555',
					textAlign: 'center',
					fontSize: '90%',
					fontWeight: 'bold',
					borderBottom: '1px solid #999999'
				}}>
					Zeitplan für {moment(this.props.timespan.start * 1000).format('dddd, DD.MM.YYYY')} bis {moment(this.props.timespan.end * 1000).format('dddd, DD.MM.YYYY')}
				</div>
				<Timeline next={(e) => this.next()} prev={(e) => this.prev()} width-before="30px" width-after="30px" timespan={this.props.timespan} />
				{
					(this.props.isDragging)?
						(this.props.move_timestamp === null)
						?<Timemarker width-before="30px" width-after="30px" timestamp={this.props.timestamp} timespan={this.props.timespan} />
						:<Timemarker width-before="30px" width-after="30px" timestamp={this.props.move_timestamp[0]} timespan={this.props.timespan} />
					:null
				}
				{
					(this.props.isDragging && this.props.move_timestamp !== null)
						?<Timemarker width-before="30px" width-after="30px" timestamp={this.props.move_timestamp[1]} timespan={this.props.timespan} />
						:null	
				}
                {
                    (this.props.loading || this.props.saving || (typeof this.props.updating !== 'undefined' && this.props.updating))?
                        <div style={{
                            flexGrow: 1,
                            overflow: 'auto',
                            paddingTop: '20px'
                        }}><Loader active inline='centered' /></div>
                    :
                        <div style={{
                            flexGrow: 1,
                            overflow: 'auto'
                        }}>
                        {
                            this.props.schedule.map((track, trackIdx) => (
                                <Track selectedItem={(this.props.selectedItem !== null && this.props.selectedItem.track === trackIdx)?this.props.selectedItem.item:null} onRemove={(itemIdx) => this.removeItem(this.props.id, itemIdx, trackIdx)} onSelect={(itemIdx) => this.selectItem(this.props.id, itemIdx, trackIdx)} onCreate={(x) => this.create(x, trackIdx)} onDragOver={(e, x, track) => this.onDragOverT(e, x, trackIdx)} onDragStart={(e, action, el, params) => this.onDragStart(e, action, trackIdx, el, params)} onDragEnd={(e, action, el) => this.onDragEnd(e, action, trackIdx, el)} before={
                                    <TrackIndex>{trackIdx + 1}</TrackIndex>
                                } key={trackIdx} items={track.items} metaitems={this.props.metaitems} corresponding={(typeof this.props.corresponding[trackIdx] !== 'undefined' && typeof this.props.corresponding[trackIdx].items !== 'undefined')?this.props.corresponding[trackIdx].items:null} width-before="30px" width-after="30px" track={track} timespan={this.props.timespan} />
                            ))
                            
                        }
                            <div style={{
                                width: '30px'
                            }}>
                                <Button size="tiny" onClick={() => this.props.add_track(this.props.id)} compact attached="bottom" color="green" icon><Icon name="plus" /></Button>
                            </div>
                        </div>
                }
				
				<Menu attached='top' style={{
					backgroundColor: '#EEEEEE',
					borderRadius: 0
				}}>
					
					<Menu.Item position='right'>
						<Button primary disabled={
                            this.props.saving
                        } onClick={() => this.props.save_schedule(this.props.id, this.props.timespan.start, this.props.timespan.end, this.props.lottery, this.props.channel, this.props.schedule)}> Zeitplan speichern</Button>
					</Menu.Item>
				</Menu>
				
			</div>
		)
	}
};

export const Schedule = connect(
  mapStateToProps,
  actionCreators
)(ScheduleComponent)